export default "__VITE_ASSET__CA1ay9m1__"